import { Controller } from "@hotwired/stimulus"

// Toggles a "More" panel of secondary filter inputs.
// Targets:
//   panel  - the collapsible container (toggles the "hidden" class)
//   icon   - optional chevron icon (rotates 180°)
//   label  - optional <span> whose text alternates between moreText and lessText values
//
// Values:
//   moreText, lessText - labels for the toggle button
export default class extends Controller {
  static targets = ["panel", "icon", "label"]
  static values = {
    moreText: String,
    lessText: String,
  }

  toggle(event) {
    if (event) event.preventDefault()
    const willHide = !this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden")

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", !willHide)
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = willHide ? this.moreTextValue : this.lessTextValue
    }
  }
}
